export const OverlayTexture = {
    Weapon: {
        SapphireWand: 'Weapon/SapphireWand',
    }
} as const;
